export default "__VITE_ASSET__a16159b7__"